module.exports = __webpack_public_path__ + "static/media/ceilingslegendaxon.7548d9eb.png";